import * as CryptoJS from 'crypto-js';
import postRobot from 'post-robot';
import axios from 'axios';
import oAuth from './oAuth';
import listenersFunc from './listenersFunc';
import { getPlatform } from './utils';
import { axiosCfm } from './axiosCfm';
import { externalBaseUrl } from './constants';

export let context = null;
export let actions = null;
export let beAxios = axiosCfm;
let fragmentsTokens = {};

export function getContext() {
    return new Promise((resolve) => {
        resolve(context);
    });
}

export function setContext(ctx) {
    return new Promise((resolve) => {
        context = {
            ...context,
            ...ctx,
        };
        resolve();
    });
}

function getFormTemplates() {
    return axios.get('/forms/v1/templates');
}

export function setAxiosDevices(instance) {
    return new Promise((resolve) => {
        beAxios = instance;
        resolve();
    });
}

export function setActions(newActions) {
    return new Promise((resolve) => {
        actions = {
            ...actions,
            ...newActions,
        };
        resolve();
    });
}

export function dispatchEvent(eventName, data) {
    const event = new CustomEvent(eventName, { detail: data });
    window.dispatchEvent(event);
}

export function loadFragment(guid, url, domEl) {
    return new Promise((resolve, reject) => {
        let el = document.getElementById(domEl);
        const iframe = document.createElement('iframe');
        fragmentsTokens[guid] = localStorage.getItem(`fmFragmentToken-${guid}`);
        iframe.name = guid;
        iframe.className = 'fm-fragment';
        iframe.src = url;
        if (context.loginToken && !fragmentsTokens[guid]) {
            oAuth(guid, context.loginToken)
                .then((res) => {
                    if (res) {
                        fragmentsTokens[guid] = res;
                        localStorage.setItem(`fmFragmentToken-${guid}`, res);
                        el.appendChild(iframe);
                        resolve();
                    } else {
                        reject({
                            code: 'loginbydevice-response-error',
                            messsage:
                                'FM Bridge-backend loadFragment oAuth loginbydevice response invalid token',
                        });
                    }
                })
                .catch(reject);
        } else {
            el.appendChild(iframe);
            resolve();
        }
        if (context.platform === 'dev') {
            context.currentDevGuid = guid;
        }
    });
}

function setListeners(liesteners) {
    liesteners.forEach((name) => {
        const func = (event) => listenersFunc[name](event.data);
        try {
            postRobot.on(name, func);
        } catch (error) {
            // console.warn(`Listener ${name} already exists`);
        }
    });
}

export function init() {
    if (!context.platform) {
        context.platform = getPlatform();
    }

    setListeners([
        'getContext',
        'getToken',
        'getNewToken',
        'getLiteral',
        'getFilteredUsers',
        'setDrilldown',
        'getFilteredPeriodString',
        'clerCache',
        // FORMS
        'getFormInitData',
        'getFormStates',
        'getValueList',
        'getFormType',
        'getRelatedEntity',
        'getUsers',
        'collapseImagesView',
        'expandImagesView',
        'finishActivity',
        'setTitle',
        'saveData',
        'openDatePicker',
        'openSignatureView',
        'showCameraImages',
        'hideCameraImages',
        'showLoading',
        'hideLoading',
        'showAlertDialog',
        'showConfirmDialog',
    ]);
}

export function cfmLogin(username, password) {
    return axios({
        method: 'post',
        url: `${context.cfmBaseUrl}/authenticate/v1/login`,
        data: { username, password },
        timeout: 30000,
        withCredentials: false,
        maxContentLength: 128 * 1024 * 1024,
        dataType: 'json',
        contentType: 'application/json',
        accept: '*/*',
    });
}

export function changeImplementation(cfmToken, implementationId) {
    return axios({
        method: 'put',
        url: `${context.cfmBaseUrl}/config/v1/changeImplementation`,
        headers: { Authorization: `Bearer ${cfmToken}` },
        contentType: 'application/json',
        accept: '*/*',
        data: {
            implementation: String(implementationId),
        },
    });
}

export function getExternalKeys(cfmToken) {
    return axios({
        method: 'get',
        url: `${context.cfmBaseUrl}/key/v1`,
        headers: { Authorization: `Bearer ${cfmToken}` },
        contentType: 'application/json',
        accept: '*/*',
    });
}

export function externalLogin(publicKey, privateKey) {
    let timestamp = (new Date().getTime() / 1000).toFixed(0);
    let message = publicKey + ':' + timestamp + ':' + privateKey;

    let secret = CryptoJS.HmacSHA256(message, privateKey);
    let secretHash = CryptoJS.enc.Base64.stringify(secret);

    return axios({
        method: 'post',
        url: `${externalBaseUrl}/login`,
        data: {
            publicKey: publicKey,
            timestamp: Number(timestamp),
            secret: secretHash,
        },
        // headers: {
        //   'Cache-Control': 'max-age=0, no-cache, must-revalidate, proxy-revalidate',
        // },
        timeout: 30000,
        withCredentials: false,
        maxContentLength: 128 * 1024 * 1024,
        dataType: 'json',
        contentType: 'application/json',
        accept: '*/*',
    });
}
